var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cell total", class: "cell__" + _vm.column },
    [
      _vm.column === "worker" ? [_vm._v(" Итого за месяц ")] : _vm._e(),
      _vm.column === "days"
        ? [
            _c(
              "div",
              { staticClass: "timeline" },
              _vm._l(_vm.stats.days, function (day) {
                return _c("div", { key: day.key, staticClass: "day" }, [
                  _vm._v(
                    " " +
                      _vm._s(Math.floor((day.totalTimeMin / 60) * 10) / 10) +
                      " "
                  ),
                ])
              }),
              0
            ),
          ]
        : _vm._e(),
      _vm.column === "totalShifts"
        ? [
            _c("div", { staticClass: "shifts" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.stats.dayShiftsCount + _vm.stats.nightShiftsCount
                  ) +
                  " "
              ),
            ]),
          ]
        : _vm._e(),
      _vm.column === "workTime"
        ? [_vm._v(" " + _vm._s(_vm.formatTime(_vm.stats.totalTimeMin)) + " ")]
        : _vm._e(),
      _vm.column === "compensation" ? [_vm._v(" 0 ")] : _vm._e(),
      _vm.column === "load" ? [_vm._v(" 0 ")] : _vm._e(),
      _vm.column === "salary"
        ? [
            _vm._v(
              " " + _vm._s(Math.round(_vm.stats.salary).toLocaleString()) + " "
            ),
          ]
        : _vm._e(),
      _vm.column === "salaryMainPart"
        ? [
            _vm._v(
              " " +
                _vm._s(Math.round(_vm.stats.salaryMain || 0).toLocaleString()) +
                " "
            ),
          ]
        : _vm._e(),
      _vm.column === "excessPremium" ? [_vm._v(" 0 ")] : _vm._e(),
      _vm.column === "Depreciation" ? [_vm._v(" 0 ")] : _vm._e(),
      _vm.column === "premium" ? [_vm._v(" 0 ")] : _vm._e(),
      _vm.column === "fine" ? [_vm._v(" 0 ")] : _vm._e(),
      _vm.column === "deductions" ? [_vm._v(" 0 ")] : _vm._e(),
      _vm.column === "totalAccrued" ? [_vm._v(" 0 ")] : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }